export const privacyPolicyUrl = "/privacy-policy";
